export const AUTO_REMINDERS_DEFAULT_VALUE = '2|10|';

export type Notification = {
  checked: boolean;
  notifCode: string;
  value?: string | null;
};
